import {
  SPECILITY_REQUEST,
  SPECILITY_SUCCESS,
  SPECILITY_ERROR,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_ERROR,
  NOTIFY_USER_NOTCOMPLETED_INSCRIPTION_REQUEST,
  NOTIFY_USER_NOTCOMPLETED_INSCRIPTION_SUCCESS,
  NOTIFY_USER_NOTCOMPLETED_INSCRIPTION_ERROR,
} from "./actions";

const initialState = {
  requesting: false,
  specilitys: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SPECILITY_REQUEST:
      return {
        ...initialState,
        requesting: false,
      };

    case SPECILITY_SUCCESS:
      return {
        requesting: false,
        specilitys: action.authData,
      };

    case SPECILITY_ERROR:
      return {
        ...initialState,
        requesting: false,
        error: JSON.parse(action.error),
      };
    case SIGNUP_REQUEST:
      return {
        requesting: true,
        authData: undefined,
      };

    case SIGNUP_SUCCESS:
      return {
        requesting: false,
        authData: action.authData,
      };

    case SIGNUP_ERROR:
      return {
        requesting: false,
        authData: undefined,
        error: JSON.parse(action.error),
      };

    // case LOGOUT_SUCCESS:
    //   return {
    //     requesting: false,
    //   };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/signup/reducer.js